import React from 'react';
import {
    Stack,
    Typography,
    Pagination,
} from '@mui/material';

interface UserPaginationProps {
    currentPage: number;
    totalPages: number;
    totalResults: number;
    resultsPerPage: number;
    onPageChange: (page: number) => void;
}

const UserPagination: React.FC<UserPaginationProps> = ({
    currentPage,
    totalPages,
    totalResults,
    resultsPerPage,
    onPageChange,
}) => {
    const startResult = (currentPage - 1) * resultsPerPage + 1;

    const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
        onPageChange(page);
    };

    return (
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            justifyContent={{ xs: 'center', sm: 'flex-end' }}
            alignItems='center'
            mt={3}
            spacing={1}
            textAlign={{ xs: 'center', sm: 'left' }}
        >
            <Typography
                fontSize={{ xs: 14, sm: 16 }}
                fontWeight={400}
                fontFamily='Poppins, sans-serif'
                color='#49454F'
            >
                Showing <b>{startResult}</b> of <b>{totalResults} results</b>
            </Typography>

            <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                size="small"
                siblingCount={0}
                sx={{
                    '& .MuiPaginationItem-root': {
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: { xs: 12, sm: 14 },
                        color: '#000',
                        minWidth: { xs: 28, sm: 36 },
                        height: { xs: 28, sm: 36 },
                        '&.Mui-selected': {
                            backgroundColor: '#fff',
                            color: '#465E91',
                        },
                    },
                }}
            />
        </Stack>
    );
};

export default UserPagination; 